export default __webpack_public_path__ + "static/media/bitblack.5ad2e4aa.svg";